export default __webpack_public_path__ + "static/media/txt_no_logo_fr.602cb015.svg";